<template>
  <div class="play">
    <barprogress v-model="value"></barprogress>
  </div>
</template>
<script>
import barprogress from '../components/progress/barprogress.vue'
export default {
  data: () => ({
    value: 0
  }),
  components: {
    barprogress
  }
}
</script>
<style lang="scss" scoped>
.play {
  padding: 30px;
}
</style>